export function transformListToMap<T extends { id: ObjectId }>(list: T[]) {
  const output = new Map<T['id'], T>();

  for (const el of list) output.set(el.id, el);

  return output;
}
